// @flow
import type { State, Action } from './types';

// $FlowFixMe
const initialState: State = {
  appName: '',
  appVersion: '',
  firebase: { remoteConfigApplied: false },
  releaseVersion: '',
};

export const CodePushEnv = {
  android: {
    '_VH9FEHBmPp4EVlaC9RELJN45HTZeox-CFrHK': 'QA',
    'yWpmP3vC3sA_XE-_SYtbj6dE174lNba58A_TY': 'Alpha',
    '03MLkVEX-ZxrklNJ45jM6Gf1PP3DVttzWXQUr': 'Beta',
    JylxBj7QmzxzchjHcdScQ8VVAgCZSVMx_zjh2: 'Production',
    'ggDEf-UWDm9opV2ASU0q7s8tA6vxE_daT_v62': 'Dev',
  },
  ios: {
    NJiFd3bD0T7sIvGO7nss8LrO6nrrU2EQ2yO4X: 'QA',
    FFOQtYrWxWGPsy9YEBSsoFoWJcAGh5a7eIjb6: 'Alpha',
    'ecMIdnm1aTzkfFItG3a-duFFM2S63PCEMc_0f': 'Beta',
    'aAt-Eib-JaAdycbFhaOPWxHDSEsPGZzHgUB7O': 'Production',
    'ba-MkUcHnI7uF47Zq7SzcjOWxoOpGBFwWf4s2': 'Dev',
  },
};

const reducer = (state: State = initialState, action: Action = { type: 'NONE' }): State => {
  switch (action.type) {
    case 'REMOTE_CONFIG_APPLIED':
      if (action.value) {
        return {
          ...state,
          firebase: { ...state.firebase, remoteConfigApplied: true },
        };
      }
      return { ...state, firebase: { remoteConfigApplied: false } };

    case 'SET_CODEPUSH_SYNC_STATUS':
      return {
        ...state,
        codepush: { ...state.codepush, syncStatus: action.status },
      };

    case 'CHANGE_ENV':
      return { ...state, base: { ...state.base, env: action.env } };

    default:
      return state;
  }
};

export default reducer;
